import React, { Component } from 'react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import LoonBelastingPdf from './LoonBelastingPdf'

export class LoonBelRapport extends Component {
  render() {
    const { data, company } = this.props
    return (
      <div className="loon-belasting">
        <h3>Loon belasting rapport</h3>
        <p>Aantal werknemers</p>
    <p>{data.aantalWerknemers}</p>
    <p>Totaal AOV</p>
    <p>SRD {data.totaalAOV}</p>
    <p>Totaal Loonbelasting</p>
    <p>SRD {data.totaalLoonbelasting}</p>
    <p>Totaal te betalen</p>
    <p>SRD {data.totaalTeBetalen}</p>
    <p>Totaal verloondbedrag</p>
    <p>SRD {data.totaalVerloondBedrag}</p>
    <PDFDownloadLink document={<LoonBelastingPdf data={data} company={company}   />} 
    fileName={`${company.companyNaam} (${company.startDatumSalarisRonde} - ${company.eindDatumSalarisRonde})`}>
    <button className='submit-button'>Download rapport</button>
      </PDFDownloadLink>
    
      </div>
    )
  }
}

export default LoonBelRapport
